import React, { useState } from 'react';
import './Hero.css';
import Header from './Header/Header';
import hero_image from '../assets/hero_image_3.png';
import hero_image_back from '../assets/hero_image_back.png';
import Heart from '../assets/heart.png';
import calories from '../assets/calories.png';
import NumberCounter from 'number-counter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import ReactModal from 'react-modal'; // Import ReactModal

const Hero = ({ onLoginClick, userEmail }) => {
  const transition = { type: 'spring', duration: 3 };
  const mobile = window.innerWidth <= 768 ? true : false;
  const [showTooltip, setShowTooltip] = useState(false);
  const [showModal, setShowModal] = useState(false); // State for modal visibility
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [gender, setGender] = useState('');
  const [message, setMessage] = useState('');

  // YouTube video ID (replace with your actual video ID)
  const youtubeVideoId = 'zSvBTWlCpic';

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message has been sent!');
    // You can add code here to actually submit the form data
    // to a server or send it via email
  };

  // Apply default styles for react-modal
  ReactModal.defaultStyles = {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
    content: {
      position: 'absolute',
      top: '40%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      border: '1px solid #ccc',
      background: '#fff',
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      borderRadius: '4px',
      outline: 'none',
      padding: '20px',
    },
  };

  const handleContactClick = () => {
    openContactModal();
  };

    const [showContactModal, setShowContactModal] = useState(false);

    const openContactModal = () => {
        setShowContactModal(true);
    };

    const closeContactModal = () => {
        setShowContactModal(false);
    };

  return (
    <div className="hero">
      <div className="blur hero-blur"></div>

      <div className="left-h">
        <Header />

        <div className="the-best-ad">
          <motion.div
            initial={{ left: mobile ? '165px' : '238px' }}
            whileInView={{ left: '8px' }}
            transition={{ ...transition, type: 'tween' }}
          ></motion.div>
          <span>the best fitness club in the town</span>
        </div>

        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div>
            <span>Ideal body</span>
          </div>
          <div>
            <span>
              In here we will help you to ahape and build your ideal body and live up yout life to fullest
            </span>
          </div>
        </div>

        <div className="figures">
          <div>
            <span>
              <NumberCounter end={140} start={69} delay="3" preFix="+" />
            </span>
            <span>expert coches</span>
          </div>
          <div>
            <span>
              <NumberCounter end={950} start={779} delay="3" preFix="+" />
            </span>
            <span>members joined</span>
          </div>
          <div>
            <span>
              <NumberCounter end={50} start={10} delay="3" preFix="+" />
            </span>
            <span>fitness progrms</span>
          </div>
        </div>

        <div className="hero-buttons">
          <button className="btn" onClick={openModal}>
            Get Started
          </button>
          <button className="btn" onClick={handleContactClick}>
            Contact Us
          </button>
        </div>
      </div>

      <div className="right-h">
        {userEmail ? (
          <div
            className="profile-container"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <FontAwesomeIcon icon={faUser} className="profile-icon" />
            {showTooltip && <span className="tooltip">{userEmail}</span>}
          </div>
        ) : (
          <button className="btn" onClick={onLoginClick}>
            Log In
          </button>
        )}
        <motion.div
          initial={{ right: '-1rem' }}
          whileInView={{ right: '4rem' }}
          transition={transition}
          className="heart-rate"
        >
          <img src={Heart} alt="" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>

        <img src={hero_image} alt="" className="hero_image" />
        <motion.img
          initial={{ right: '9rem' }}
          whileInView={{ right: '23rem' }}
          transition={transition}
          src={hero_image_back}
          alt=""
          className="hero_image_back"
        />

        <motion.div
          initial={{ right: '37rem' }}
          whileInView={{ right: '28rem' }}
          transition={transition}
          className="calories"
        >
          <img src={calories} alt="" />
          <div>
            <span>Calories Burned</span>
            <span>220 kcal</span>
          </div>
        </motion.div>
      </div>

      {/* ReactModal for YouTube Video */}
      <ReactModal
        isOpen={showModal}
        onRequestClose={closeModal}
        contentLabel="YouTube Video"
      >
        <div className="modal-content">
          <button className="close-button" onClick={closeModal}>
            X
          </button>
          <div className="youtube-container">
            <iframe
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${youtubeVideoId}`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </ReactModal>

                {/* Contact Us Modal */}
                <ReactModal
                    isOpen={showContactModal}
                    onRequestClose={closeContactModal}
                    contentLabel="Contact Us"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0.75)'
                        },
                        content: {
                            position: 'absolute',
                            top: '40%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            border: '1px solid #ccc',
                            background: '#fff',
                            overflow: 'auto',
                            WebkitOverflowScrolling: 'touch',
                            borderRadius: '4px',
                            outline: 'none',
                            padding: '20px'
                        }
                    }}
                >
                    <div className="modal-content">
                        <button className="close-button" onClick={closeContactModal}>
                            X
                        </button>
                        <div className="contact-form-container">
                            <h2>Contact Us</h2>
                            <form id="contact-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="name">Name:</label>
                                    <input
                                        type="text"
                                        id="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="address">Address:</label>
                                    <input
                                        type="text"
                                        id="address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="gender">Gender:</label>
                                    <select id="gender" value={gender} onChange={(e) => setGender(e.target.value)} required>
                                        <option value="">Select Gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="message">Message:</label>
                                    <textarea
                                        id="message"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        rows="4"
                                        required
                                    ></textarea>
                                </div>

                                <button type="submit" className="btn">
                                    Send Message
                                </button>
                            </form>
                        </div>
                    </div>
                </ReactModal>
    </div>
  );
};

export default Hero;
